<template>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" fill="currentColor" viewBox="0 0 24 24"><path d="M14 10h1v8h-1zM18 10h1v8h-1zM12 2 2 9h20L12 2zm0 1.2L18.8 8H5.2L12 3.2zM9 10h1v8H9zM3 19h18v1H3zM5 10h1v8H5zM3 21h18v1H3z"/><path d="M0 0h24v24H0V0z" style="fill:none"/></svg>
</template>

